import React from 'react'
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as RiIcons from 'react-icons/ri';
import { confirmAlert } from 'react-confirm-alert'; 

export const ExportToExcel = ({ apiData, fileName }) => {
  const fileType ="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const getalert = (apiData, fileName) => { 
    confirmAlert({
      title: 'Confirm to Export',
      message: 'Are you sure you want to Export this data into Excel format',
      buttons: [
        {
          label: 'Yes',
          onClick: () =>{
            const ws = XLSX.utils.json_to_sheet(apiData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
          }
        },
        {
          label: 'No',
          onClick: () =>{
          } 
        }
      ]
    });
  } 


  return (
    <RiIcons.RiFileExcel2Fill style={{marginRight:"20px",color: "#17a2b8",height:"20px",width:"20px"}} 
    onClick={(e) => getalert(apiData, fileName)}   />
  );
};